import mod from "-!./Footer.ts?vue&type=script&lang=ts&"; export default mod; export * from "-!./Footer.ts?vue&type=script&lang=ts&"